<table mat-table [dataSource]="appointments$ | async" #appointmentsTable>
  <ng-container matColumnDef="address">
    <th mat-header-cell *matHeaderCellDef>{{ 'appointment.address' | translate }}</th>
    <td mat-cell *matCellDef="let appointment">{{ appointment.address }}</td>
  </ng-container>

  <ng-container matColumnDef="customer">
    <th mat-header-cell *matHeaderCellDef>{{ 'core.customer' | translate }}</th>
    <td mat-cell *matCellDef="let appointment">{{ appointment.customer }}</td>
  </ng-container>

  <ng-container matColumnDef="note">
    <th mat-header-cell *matHeaderCellDef>{{ 'appointment.note' | translate }}</th>
    <td mat-cell *matCellDef="let appointment">{{ appointment.note }}</td>
  </ng-container>

  <ng-container matColumnDef="participants">
    <th mat-header-cell *matHeaderCellDef>{{ 'appointment.participants' | translate }}</th>
    <td mat-cell *matCellDef="let appointment">{{ appointment.participants }}</td>
  </ng-container>

  <ng-container matColumnDef="time">
    <th mat-header-cell *matHeaderCellDef>{{ 'appointment.time' | translate }}</th>
    <td mat-cell *matCellDef="let appointment">{{ appointment.date | date:'shortTime' }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let appointment" class="actions-column" (click)="$event.stopPropagation()">
      <mat-menu #driverActions>
        <button mat-menu-item (click)="editAppointment(appointment)">{{ 'appointment.actions.edit' | translate }}</button>
        <button mat-menu-item *ngxPermissionsOnly="['ROLE_USER']" (click)="deleteAppointment(appointment['@id'])">{{ 'appointment.actions.delete' | translate }}</button>
      </mat-menu>

      <button mat-button [matMenuTriggerFor]="driverActions">
        <mat-icon inline="true">more_vert</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let appointment; columns: tableColumns" (click)="editAppointment(appointment)"></tr>
</table>

@if (appointmentsTable.dataSource.length == 0 ) {
  <app-no-result-message></app-no-result-message>
}

@if (actionPending$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
